﻿/**
 * Utils.js provides common functionality and utilities for all pages.
 */

import 'core-js/stable';
import 'whatwg-fetch';
import 'regenerator-runtime/runtime';
import * as Sentry from '@sentry/browser';

const userErrorDialog = document.getElementById('error-dialog');
const userErrorText = document.getElementById('error-dialog-text');
/**
 * Maps attributes to validator names and options.
 */
const attValidators = {
	// Required
	['data-val-required']: function(value) {
		return ['presence', {message: value}];
	},
	['required']: function (value) {
		return ['presence', { message: value }];
	},
	// Range
	['data-val-maxlength-max']: function (value, elem) {
		return ['length', {
			maximum: parseInt(value),
			message: elem.getAttribute('data-val-maxlength')
		}];
	},
	['minlength']: function (value) {
		return ['length', {
			minimum: parseInt(value)
		}];
	},
	['maxlength']: function (value) {
		return ['length', {
			maximum: parseInt(value)
		}];
	},
	// Numeric range
	['min']: function (value) {
		return ['numericality', {
			greaterThanOrEqualTo: parseInt(value)
		}];
	},
	['max']: function (value) {
		return ['numericality', {
			lessThanOrEqualTo: parseInt(value)
		}];
	},
	// Pattern
	['pattern']: function (value) {
		return ['format', value];
	},
	// Email
	['data-val-email']: function (value) {
		return ['email', {message: value}];
	}
};

/**
 * Requires an argument to be present.
 * @param {string} name The name of the argument in the error message.
 * @example function func(arg = argRequired('arg'))
 * @throws Throws a developer friendly error message for the argument.
 */
export function argRequired(name) {
	throw `The ${name} argument is required!`;
}

/**
 * Wraps a fetch promise, preventing it from throwing. Instead returning a Service Unavailable
 * status.
 * @param {any} promise The promise returned by calling fetch.
 * @returns The wrapped promise.
 */
export function wrapFetch(promise) {
	return promise.catch(err => {
		// Disguised duck (Response). Assumes the server had an error.
		return {
			ok: false,
			status: 503,
			statusText: 'Service Unavailable'
		};
	});
}

/**
 * Checks a fetch request, throwing the status message if there was an error status code.
 * @param {any} res The response.
 */
export async function checkFetch(res = argRequired('res')) {
	if (!res.ok)
		throw `${res.statusText} (${res.status})`;
}

/**
 * Collects form data into an object.
 * @param {HTMLFormElement} form The form to collect elements from.
 * @returns The form data in the form of an object.
 */
export function getFormData(form = argRequired('form')) {
	const data = {}
	for (let elem of form.elements)
		if (elem.value !== '')
			data[elem.name] = elem.value;
	return data;
}

/**
 * Collects validation attributes from form elements.
 * @param {HTMLFormElement} form The form.
 */
export function getValidationConstraints(form = argRequired('form')) {
	const constraints = {}
	for (let elem of form.elements) {
		// Add attribute.
		constraints[elem.name] = {}
		for (let [attr, getValidator] of Object.entries(attValidators)) {
			let value = elem.getAttribute(attr, elem);
			if (value != null) {
				// Add validator.
				let [valName, valOptions] = getValidator(value, elem);
				constraints[elem.name][valName] = valOptions;
			}
		}
	}
	return constraints
}

/**
 * Clears the validation errors.
 * @param {any} form The form.
 */
export function clearValidationErrors(form = argRequired('form')) {
	let errorsList = form.querySelector('ul.validation-errors');
	if (errorsList != null)
		errorsList.innerHTML = '';
}

/**
 * Displays validation errors.
 * @param {HTMLFormElement} form The form.
 * @param {Object} errors Key-value pairs of input names and errors.
 */
export function showValidationErrors(form = argRequired('form'), errors = argRequired('errors')) {
	// Get the list.
	let errorsList = form.querySelector('ul.validation-errors');
	if (errorsList == null) {
		errorsList = document.createElement('ul');
		errorsList.classList.add('validation-errors');
		form.insertAdjacentElement('beforeend', errorsList);
	} else {
		// Clear existing errors.
		errorsList.innerHTML = '';
	}
	// Add errors.
	for (let [_, errs] of Object.entries(errors)) {
		console.log(_, errs);
		for (let err of errs) {
			console.log(err);
			let li = document.createElement('li');
			li.textContent = err;
			errorsList.appendChild(li);
		}
	}
}

/**
 * Shows a message to the user.
 * @param {string} msg The message to display.
 * @param {string?} level The importance of the message (defaults to info).
 * Currently supported: success, danger, warning, info.
 */
export function showMessage(msg = argRequired('msg'), level = 'info') {
	// Track message.
	Sentry.captureMessage(`User message (${level}): ${msg}`);
    // Set the message.
	userErrorText.textContent = msg;
	// Remove current alert styles.
	for (let cls of userErrorDialog.classList)
		if (cls.startsWith('alert-'))
			userErrorDialog.classList.remove(cls);
	userErrorDialog.classList.add('alert-' + level);
	// Display the error.
    userErrorDialog.style.display = 'block';
}

// Track errors with Sentry.
Sentry.init({
	dsn: 'https://e1ceb0bf47b54fcdab7288cdf078a3af@sentry.io/5178040',
	beforeSend(event) {
		// Check if it is an exception, and if so, show the report dialog
		if (event.exception) {
			Sentry.showReportDialog({ eventId: event.event_id });
		}
		return event;
	}
});

/**
 * Reports an error.
 * @param {string} err The error.
 */
export function reportError(err) {
	console.warn(err);
	Sentry.captureException(err);
}

// Allow the user to close the dialog.
document.getElementById('error-dialog-exit').addEventListener('click', () =>
	userErrorDialog.style.display = 'none')

var button = document.getElementById('BtnToggleMenu');
button.addEventListener('click', ToggleMobileNav);
// Toggles the mobile navigation
function ToggleMobileNav() {
	document.getElementById('NavigationContainer').classList.toggle('hide');
}; //end ToggleMobileNav
